import { Component, Vue } from "vue-property-decorator";
import Cookies from 'js-cookie';

import { Loading, Hint } from "@/components";
import { LoginModel } from "@/models";
// import { EtoeeModel } from "@/models";
import { TCBReceiptApi } from "@/network/pb/proto";
import { AuthType, Network } from "@/network";
import { router } from "@/router";
import { ErrorCode } from "@/constant";
import { Encrypt } from "@/util/Encrypt";



@Component<LoginResetController>({
    components: {
        Loading,
        Hint,
    },
})
export default class LoginResetController extends Vue {
    private isLoading = true;
    private doubleClick = false;

    private reset: {
        new: string,
        again: string,
    } = {
        new: "",
        again: "",
    }
    private errMsg: {
        new: string,
        again: string,
    } = {
        new: "",
        again: "",
    };

    // Hint
    private isDone = false;
    private hintBox: {show: boolean, hint: string} = {show: false, hint: ""};

    public async created() {
        this.isLoading = false;

        await this.checkIsTimeOut();
    }

    private async checkIsTimeOut() {
        this.isLoading = true;

        /* send value */
        // const token = "eyJhbGciOiJBMTI4S1ciLCJlbmMiOiJBMTI4Q0JDLUhTMjU2IiwidHlwIjoiSldUIn0.sv4dwaguUa3MNk8FZy7yAYU6xl2JUBvLYEnwjgPs_LDhgqQ5f9wNzA.D2dwm7ZWVlBmQhDf8ePBKw.AHQha_pw1ihOtQOCW5JdkBT-ER4oiyUPBmK6zdInRfDBAXL-7pY1SVVr7BT66lARAZTHq4moZCmwIFGe-AJxrx_W7dIpFGbbLuCbqOWeKjV39c9dSDsGWB-Ixd9MTQ1wsE78JpIqIUCoQwLz7e82BcrTcOTuvE2yb35or7K0bmtveGwAa_PWvMabBOf2nD1VN6O5g3IjYP_VVYKtlwVHzPHrP5tDQOnB0i2MmVEOY9Yf1i81D8UKP214i-PU7OMswNArqC9eJI0og-tpQwtrqHaqVKRwaV6OtGzSuagNj3M.yua1qMGUVm9QEx2kjtQmtw";

        if (!(this.$route.query && this.$route.query.token)) {
            this.$router.push("/login");
        }
        const token = this.$route.query.token;

        Cookies.set("appToken", token as string, { sameSite: 'strict' });
        Network.setAuth(AuthType.JWT, token as string);

        const errorCode = await LoginModel.checkResetPasswordPeriod();
        console.log("checkResetPasswordPeriod errorCode");
        console.log(errorCode);

        switch (errorCode) {
            case TCBReceiptApi.Protobuf.ErrorCode.EC_SUCESS: 
                break;
            case TCBReceiptApi.Protobuf.ErrorCode.EC_RESET_PASSWORD_EXPIRED:
                this.isDone = true;
                this.openHint("已超過規範時間，請重新操作");
                break;
            default:
                this.isDone = true;
                this.openHint("例外狀況");
        } 
        /* send value */

        this.isLoading = false;
    }

    private async checkAndSubmit() {
        let isEmpty = false;
        this.errMsg.new = "";
        this.errMsg.again = "";

        if (this.reset.new === "") {
            this.errMsg.new = "*必填";
            isEmpty = true;
        }
        if (this.reset.new !== this.reset.again) {
            this.errMsg.again = "*密碼錯誤，與上方密碼不符";
            isEmpty = true;
        }

        if (isEmpty) return false;

        await this.submit();
    }
    
    private async submit() {

        if (!this.doubleClick) {
            this.doubleClick = true;
            this.isLoading = true;

            const encoder = new TextEncoder();
            /* send value */
            const crypted2 = await Encrypt.getE2EEpd(this.reset.new);//將密碼做JS加密
            const passwordMotify = TCBReceiptApi.Protobuf.PasswordMotify.create({
                newPassword: encoder.encode(this.reset.new),/*舊規則 */
                etoeePassword: crypted2, /*E2EE:新規則 */
            });
            const resetQuery = TCBReceiptApi.Protobuf.PasswordMotify.encode(passwordMotify).finish();
            const errorCode = await LoginModel.resetPassword(resetQuery);
            console.log("resetPassword errorCode");
            console.log(errorCode);

            switch (errorCode) {
                case TCBReceiptApi.Protobuf.ErrorCode.EC_SUCESS:
                    this.isDone = true;
                    this.openHint("已成功重置密碼");
                    break;
                case TCBReceiptApi.Protobuf.ErrorCode.EC_PASSWORD_LENGTH_ERROR:
                    this.openHint("密碼不應少於六位");
                    break;
                case TCBReceiptApi.Protobuf.ErrorCode.EC_PASSWORD_FORMAT_ERROR:
                    this.openHint("密碼格式錯誤");
                    break;
                case TCBReceiptApi.Protobuf.ErrorCode.EC_SAME_PASSWORD_ERROR:
                    this.openHint("新密碼不得與原密碼相同");
                    break;                          
                default:
                    this.isDone = true;
                    this.openHint("例外狀況");
            }
            /* send value */

            this.doubleClick = false;
            this.isLoading = false;
        }
    }

    /* Hint */
    private openHint(hint: string) {
        this.hintBox.show = true;
        this.hintBox.hint = hint;
    }

    private closeHint() {
        this.hintBox.show = false;
        this.hintBox.hint = "";

        if (this.isDone) {
            this.$router.push("/login");
        }
    }
    /* Hint */
}